import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";

import { RoundForm } from "../components";
import { useRound, useUpdateRound } from "../hooks";
import { X } from "lucide-react";

type IUpdateRound = {
  id: string;
};

export const UpdateRound: React.FC = () => {
  const { id } = useParams<IUpdateRound>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/rounds");
    }
  }, []);

  const { form, submit, loading } = useUpdateRound({
    id: +id!,
    onCompleted: () => {
      toast.success("La tournée a été modifiée avec succès");
    },
  });

  const { data } = useRound(+id!);

  useEffect(() => {
    if (data?.round?.ok && data?.round?.result) {
      const input = form.getValues();
      const { result } = data?.round;

      Object.keys(result).forEach((key) => {
        if (Object.keys(input).includes(key)) {
          // @ts-ignore
          form.setValue(key, result[key]);
        }
      });
    }
  }, [data]);

  return (
    <>
      <Header
        title="Round"
        subtitle="Mise à jour d'une tournée"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/rounds`,
            icon: <X />,
          },
        ]}
      />
      <div className="main-container">
        <RoundForm loading={loading} submit={submit} form={form} />
      </div>
    </>
  );
};
